// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__21WI_","left":"InfoRow_left__2vYoK"};